import { ApplicantDocument } from './../../core/entities/applicant';
import { fromJS } from "immutable";
import { RootStateOrAny } from "react-redux";
import { AnyAction } from "redux";
import dot from "dot-object";
import {
  SET_SHOW_PROMPT,
  //break
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  UPLOAD_APPLICANT_DOCUMENTS,
  UPLOAD_APPLICANT_DOCUMENTS_SUCCESS,
  UPLOAD_APPLICANT_DOCUMENTS_FAILURE,
  DELETE_APPLICANT_DOCUMENTS,
  DELETE_APPLICANT_DOCUMENTS_SUCCESS,
  DELETE_APPLICANT_DOCUMENTS_FAILURE,
  ADD_APPLICANT_REQUEST,
  ADD_APPLICANT_SUCCESS,
  ADD_APPLICANT_FAILURE,
  FETCH_APPLICANTS_REQUEST,
  FETCH_APPLICANTS_SUCCESS,
  FETCH_APPLICANTS_FAILURE,
  FETCH_APPLICANT_REQUEST,
  FETCH_APPLICANT_SUCCESS,
  FETCH_APPLICANT_FAILURE,
  UPDATE_APPLICANT_REQUEST,
  UPDATE_APPLICANT_SUCCESS,
  UPDATE_APPLICANT_FAILURE,
  CHECK_SCHEDULE_REQUEST,
  CHECK_SCHEDULE_SUCCESS,
  CHECK_SCHEDULE_FAILURE,
  RESET_IS_UPDATE_SUCCESSFUL,
  SET_FAILED_DEFAULT_KEY,
  SET_RESUME_FILENAME,
  RESET_APPLICANTS_STATE,
  RESET_APPLICANT_STATE,
  CLEAR_APPLICANT_VALUES,
  FETCH_TOTAL_APPLICANTS_FAILURE,
  CLEAR_TOTAL_APPLICANTS,
  FETCH_TOTAL_APPLICANTS_REQUEST,
  FETCH_TOTAL_APPLICANTS_SUCCESS,
  FETCH_APPLICANTS_AFTER_A_YEAR_COUNT,
  FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_SUCCESS,
  FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_FAILURE,
  RESET_ISOVERLAP,
} from "./actionTypes";
import { LOGOUT } from "../auth/actionType";
import { Timestamp } from "../../firebase";

export const initialState = {
  show_prompt: true,
  applicant: {
    fullName: "",
    positionApplied: "",
    expectedSalary: null,
    birthDate: "",
    civilStatus: "",
    degree: "",
    dateCompleted: "",
    school: "",
    course: "",
    referredBy: "",
    image: "",
    portfolio: "",
    skills: [],
    address: "",
    characterReference: [],
    contactNumber: "",
    contactTime: "",
    email: "",
    linkedinUrl: "",
    willingToRelocate: "",
    yearsOfExperience: "",
    recentWork: "",
    reasonOfLeaving: "",
    toolsUsed: "",
    agileExperience: "",
    workOffice: "",
    platformApplied: "",
    resume: "",
    scheduleDate: null,
    documents: [],
  },
  totalApplicants: null,
  totalApplicantsLoading: false,
  resumeFileName: "",
  applicants: [],
  isLoading: false,
  isUpdating: false,
  isUploadApplicantDocumentsLoading: false,
  isUploadApplicantDocumentsSuccessful: null,
  isDeleteApplicantDocumentsLoading: false,
  isDeleteApplicantDocumentsSuccessful: null,
  isOverlap: null,
  isChecking: false,
  error: "",
  isAddSuccessful: null,
  isUpdateSuccessful: null,
  isCheckScheduleSuccessful: false,
  failedActiveKey: "",
  invalidApplicantsTotal: {
    unread: 0,
    read: 0,
    newApplicantFailed: 0,
    shortlistedFailed: 0,
    technicalExamFailed: 0,
    initialInterviewFailed: 0,
    psychologicalExamFailed: 0,
  },
  invalidApplicantsLoading: false,
};

const reducer = (
  state: RootStateOrAny = initialState,
  action: AnyAction
): object => {
  const { type, payload } = action;
  switch (type) {
    case SET_SHOW_PROMPT:
      return (
        // @ts-ignore
        fromJS(state)
          //@ts-ignore
          .updateIn(["show_prompt"], () => payload)
          .toJS()
      );
    case UPLOAD_IMAGE:
      return {
        ...state,
        isLoading: true,
      };
    case UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        applicant: {
          ...state.applicant,
          image: payload.imageUri,
        },
      };
    case UPLOAD_APPLICANT_DOCUMENTS:
      return {
        ...state,
        isUploadApplicantDocumentsLoading: true,
        isUploadApplicantDocumentsSuccessful: null,
        error: "",
      };
    case UPLOAD_APPLICANT_DOCUMENTS_SUCCESS: 
      return {
        ...state, 
        isUploadApplicantDocumentsLoading: false,
        isUploadApplicantDocumentsSuccessful: true,
        applicant: {
          ...state.applicant,
          documents: [...(state.applicant?.documents || []), payload.document],
        },
        error: "",
      };
    case UPLOAD_APPLICANT_DOCUMENTS_FAILURE: 
      return {
        ...state,
        isUploadApplicantDocumentsLoading: false,
        isUploadApplicantDocumentsSuccessful: false,
        error: payload.error,
      };
    case DELETE_APPLICANT_DOCUMENTS:
      return {
        ...state,
        isDeleteApplicantDocumentsSuccessful: null,
        isDeleteApplicantDocumentsLoading: true,
        error: "",
      };
    case DELETE_APPLICANT_DOCUMENTS_SUCCESS: 
      return {
        ...state,
        isDeleteApplicantDocumentsSuccessful: true,
        isDeleteApplicantDocumentsLoading: false,
        applicant: {
          ...state.applicant,
          documents: state.applicant?.documents.filter((doc: ApplicantDocument) => doc.src !== payload.document.src),
        },
        error: "",
      };
    case DELETE_APPLICANT_DOCUMENTS_FAILURE: 
      return {
        ...state,
        isDeleteApplicantDocumentsSuccessful: false,
        isDeleteApplicantDocumentsLoading: false,
        error: payload.error,
      };
    case ADD_APPLICANT_REQUEST:
      return {
        ...state,
        isLoading: true,
        applicant: {
          ...state.applicant,
          ...payload.applicant,
        },
        isAddSuccessful: null,
        error: "",
      };
    case ADD_APPLICANT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        applicant: {
          ...initialState.applicant,
        },
        resumeFileName: "",
        isAddSuccessful: true,
        error: "",
      };
    case FETCH_APPLICANTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        applicants: [],
      };
    case FETCH_APPLICANTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        applicants: payload.applicants,
      };
    case FETCH_APPLICANT_REQUEST:
      return {
        ...state,
        isLoading: true,
        applicant: {
          ...initialState.applicant,
        },
        error: "",
      };
    case FETCH_APPLICANT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        applicant: {
          ...payload.applicant,
        },
      };
    case UPDATE_APPLICANT_REQUEST: {
      const params: any = dot.object({ ...payload.data });
      let schedDate = state.applicant?.scheduleDate;
      if ("scheduleDate" in params) {
        if ("technicalExam" in params.scheduleDate) {
          Object.keys(params?.scheduleDate?.technicalExam).forEach((val) => {
            if (params?.scheduleDate?.technicalExam?.[val] !== null) {
              params.scheduleDate.technicalExam[
                val
              ] = Timestamp.fromDate(
                params?.scheduleDate?.technicalExam?.[val]
              );
            }
          });
          schedDate = {
            ...state.applicant?.scheduleDate,
            technicalExam: {
              ...state.applicant?.scheduleDate?.technicalExam,
              ...params?.scheduleDate?.technicalExam,
            },
          };
        } else {
          Object.keys(params?.scheduleDate).forEach((val) => {
            if (params?.scheduleDate?.[val] !== null) {
              params.scheduleDate[val] = Timestamp.fromDate(
                params?.scheduleDate?.[val]
              );
            }
          });
          schedDate = {
            ...state.applicant?.scheduleDate,
            ...params?.scheduleDate,
          };
        }

        return {
          ...state,
          isUpdating: true,
          error: "",
          isUpdateSuccessful: null,
          applicant: {
            ...state.applicant,
            scheduleDate: schedDate,
          },
        };
      }
      return {
        ...state,
        isUpdating: true,
        error: "",
        isUpdateSuccessful: null,
      };
    }
    case UPDATE_APPLICANT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        isUpdateSuccessful: true,
      };
    case UPDATE_APPLICANT_FAILURE:
      return {
        ...state,
        isUpdateSuccessful: false,
        error: payload.error,
        isUpdating: false,
        applicant: state.applicant,
      };
    case CHECK_SCHEDULE_REQUEST: {
      return {
        ...state,
        isChecking: true,
        error: "",
        isCheckScheduleSuccessful: null,
      };
    }
    case CHECK_SCHEDULE_SUCCESS:
      let result = payload.isOverlap;
      return {
        ...state,
        isChecking: false,
        isOverlap: result,
        isCheckScheduleSuccessful: true,
      };
    case CHECK_SCHEDULE_FAILURE:
      return {
        ...state,
        isOverlap: null,
        isCheckScheduleSuccessful: false,
        error: payload.error,
        isChecking: false,
      };
    case RESET_IS_UPDATE_SUCCESSFUL:
      return {
        ...state,
        isUpdateSuccessful: null,
        error: "",
      };
    case ADD_APPLICANT_FAILURE:
      return {
        ...state,
        error: payload.error,
        isAddSuccessful: false,
      };
    case UPLOAD_IMAGE_FAILURE:
    case FETCH_APPLICANTS_FAILURE:
    case FETCH_APPLICANT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    case SET_FAILED_DEFAULT_KEY:
      return {
        ...state,
        failedActiveKey: payload.key,
      };
    case SET_RESUME_FILENAME:
      return {
        ...state,
        resumeFileName: payload.filename,
      };
    case RESET_APPLICANTS_STATE:
      return {
        ...state,
        applicants: [],
      };
    case RESET_APPLICANT_STATE:
      return {
        ...state,
        applicant: initialState.applicant,
      };
    case RESET_ISOVERLAP:
      return {
        ...state,
        isOverlap: null,
      };
    case FETCH_TOTAL_APPLICANTS_REQUEST:
      return {
        ...state,
        totalApplicantsLoading: true,
      };
    case FETCH_TOTAL_APPLICANTS_SUCCESS:
      return {
        ...state,
        totalApplicants: payload.data,
        totalApplicantsLoading: false,
      };
    case FETCH_TOTAL_APPLICANTS_FAILURE:
      return {
        ...state,
        totalApplicantsLoading: false,
      };
    case FETCH_APPLICANTS_AFTER_A_YEAR_COUNT:
      return {
        ...state,
        invalidApplicantsLoading: true,
      };
    case FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_SUCCESS:
      return {
        ...state,
        invalidApplicantsTotal: {
          ...state.invalidApplicantsTotal,
          [payload.status]: payload.total,
        },
        invalidApplicantsLoading: false,
      };
    case FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_FAILURE:
      return {
        ...state,
        invalidApplicantsLoading: false,
      };
    case CLEAR_TOTAL_APPLICANTS:
      return {
        ...state,
        totalApplicants: null,
      };   
    case CLEAR_APPLICANT_VALUES:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
